export const PRO_PLUS_SOFT_BUNDLE_CODES_MAP = {
  PRO_ZSU: 'pro_zsu',
  PRO_ZUU: 'pro_zuu',
  PRO_ZAU: 'pro_zau',
};

export const PRO_PLUS_SOFT_BUNDLE_CODES = Object.values(PRO_PLUS_SOFT_BUNDLE_CODES_MAP);

const PRO_PLUS_SOFT_BUNDLE_NAME_INFO = {
  meeting_zp_plus: 'pro_plus' // combine zoom meeting pro and zp
}

const BIZ_PLUS_SOFT_BUNDLE_NAME_INFO = {
  clinical: 'clinical',
}

const PBX_SOFT_BUNDLE_NAME_INFO = {
  brick_mortar: 'brick_mortar',
}

export const PRO_PLUS_SOFT_BUNDLE_NAME_LIST = Object.values(PRO_PLUS_SOFT_BUNDLE_NAME_INFO);
export const BIZ_PLUS_SOFT_BUNDLE_NAME_LIST = Object.values(BIZ_PLUS_SOFT_BUNDLE_NAME_INFO);
export const PBX_SOFT_BUNDLE_NAME_LIST = Object.values(PBX_SOFT_BUNDLE_NAME_INFO);

export const SOFT_BUNDLE_NAME_INFO = {
  ...PRO_PLUS_SOFT_BUNDLE_NAME_INFO,
  ...BIZ_PLUS_SOFT_BUNDLE_NAME_INFO,
  ...PBX_SOFT_BUNDLE_NAME_INFO,
  professional: 'professional'
}

export const JOINT_SALE_SOFT_BUNDLE_TYPE = {
  useInCoupon: 0, // bundle plan price use coupon
  usePriceEngine: 1, // bundle plan price use price engine
}

export const SOFT_BUNDLE_PLAN_GROUP = 'softBundleGroup';
